module.exports = __webpack_public_path__ + "img/logo.d3452568.png";